import React from 'react';
import TermsHeader from '../../components/TermsHeader';

const RaskingTermsAndConditions = () => {
  return (
    <div id="terms-wrapper">
        <TermsHeader title="Rasking Food" />
        <div className="terms-page"> 
        <p>
            Welcome to the Rasking Grilled Chicken And Steak App! These terms and conditions outline the
            rules and regulations for the use of our app. By using the Restaurant
            App, you accept and agree to be bound by these terms and conditions. If
            you disagree with any part of these terms and conditions, please do not
            use our app.
        </p>
        <h2>1. Account Creation</h2>
        <p>
            To access certain features of the Restaurant App, you may need to create
            an account. You are responsible for maintaining the confidentiality of
            your account login information and for all activities that occur under
            your account.
        </p>
        <h2>2. Ordering and Payments</h2>
        <p>
            The Restaurant App allows users to place orders and make payments for
            food and beverages. All transactions are processed securely. The app
            will store your payment information for convenience and future use in
            accordance with our privacy policy.
        </p>
        <h2>3. Restaurant Listings</h2>
        <p>
            The Restaurant App provides listings and information about various
            restaurants. While we strive to provide accurate and up-to-date
            information, we cannot guarantee the availability of menu items, prices,
            or opening hours. Please verify these details directly with the
            respective restaurants.
        </p>
        {/* More terms and conditions sections go here */}
        <h2>6. Intellectual Property</h2>
        <p>
            The Restaurant App, including its design, logo, and content, is the
            intellectual property of the Restaurant App. Users may not reproduce,
            distribute, or modify any part of the app without explicit permission
            from the Restaurant App.
        </p>
        <h2>7. Modifications</h2>
        <p>
            The Restaurant App reserves the right to modify or update these terms
            and conditions at any time. It is the responsibility of the users to
            review the terms periodically. Continued use of the app after any
            modifications constitutes acceptance of the updated terms and
            conditions.
        </p>
        <p>
            Please review the full terms and conditions carefully before using the
            Restaurant App. If you have any questions or concerns, please contact us
            at info@pands.app.
        </p>
        </div>
    </div>
  );
};

export default RaskingTermsAndConditions;
